/*
    创建者：shuxiaokai
    创建时间：2020-05-13 11:38
    模块名称：地区选择
    备注：xxxx
*/
<template>
    <div class="s-time-select">
        <el-tooltip effect="dark" transition="none" content="除开(中国香港，中国台湾省)" placement="bottom">
            <div class="select-item">全国</div>
        </el-tooltip>
        <el-tooltip disabled effect="dark" transition="none" content="2020年" placement="bottom">
            <div class="select-item">四川</div>
        </el-tooltip>
        <el-tooltip disabled effect="dark" transition="none" content="2019年" placement="bottom">
            <div class="select-item">上海</div>
        </el-tooltip>
        <el-tooltip disabled effect="dark" transition="none" content="2019年" placement="bottom">
            <div class="select-item">云南</div>
        </el-tooltip>
        <div class="mr-2 gray-400">|</div>
        <el-tooltip disabled effect="dark" transition="none" content="2019年" placement="bottom">
            <s-tooltip :isShow.sync="isShowContent" title="自定义地区选择">
                <div class="more" @click="isShowContent = true">
                    <i class="f-sm el-icon-setting"></i>&nbsp;
                    <span>自定义</span>
                </div>
                <div slot="content" class="self-content">
                    <div class="area-wrap">
                        <el-tabs v-model="activeName" type="card">
                            <el-tab-pane label="省份" name="s-a">
                                <div class="province">
                                    <div class="province-list">
                                        <div class="area-item text-ellipsis active">北京</div>
                                        <div class="area-item text-ellipsis">上海</div>
                                        <div class="area-item text-ellipsis">四川</div>
                                        <div class="area-item text-ellipsis">四川</div>
                                        <div class="area-item text-ellipsis">四川</div>
                                        <div class="area-item text-ellipsis">四川</div>
                                        <div class="area-item text-ellipsis">四川</div>
                                        <div class="area-item text-ellipsis">四川</div>
                                        <div class="area-item text-ellipsis">四川</div>
                                        <div class="area-item text-ellipsis">四川</div>
                                        <div class="area-item text-ellipsis">四川</div>
                                        <div class="area-item text-ellipsis">四川</div>
                                        <div class="area-item text-ellipsis">四川</div>
                                        <div class="area-item text-ellipsis">四川</div>
                                        <div class="area-item text-ellipsis">四川</div>
                                        <div class="area-item text-ellipsis">四川</div>
                                        <div class="area-item text-ellipsis">四川</div>
                                        <div class="area-item text-ellipsis">四川</div>
                                        <div class="area-item text-ellipsis">四川</div>
                                        <div class="area-item text-ellipsis">四川</div>
                                        <div class="area-item text-ellipsis">四川</div>
                                        <div class="area-item text-ellipsis">四川</div>
                                        <div class="area-item text-ellipsis">四川</div>
                                        <div class="area-item text-ellipsis">四川</div>
                                        <div class="area-item text-ellipsis">四川</div>
                                        <div class="area-item text-ellipsis">四川</div>
                                        <div class="area-item text-ellipsis">四川</div>
                                        <div class="area-item text-ellipsis">四川</div>
                                        <div class="area-item text-ellipsis">四川</div>
                                      
                                    </div>
                                    <div class="operation">
                                        <div>添加已选地区</div>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="城市" name="s-b"> </el-tab-pane>
                            <el-tab-pane label="区县" name="s-c"> </el-tab-pane>
                        </el-tabs>                        
                    </div>

                    <el-divider content-position="left">已选择</el-divider>
                    <div class="h-20 px-2 y-auto">
                        <el-tag class="mr-1 mb-1" closable>北京市/北京市/东城区</el-tag>
                        <el-tag class="mr-1 mb-1" closable>四川省/绵阳市/涪城区</el-tag>
                        <el-tag class="mr-1 mb-1" closable>四川省/绵阳市/涪城区</el-tag>
                        <el-tag class="mr-1 mb-1" closable>四川省/绵阳市/涪城区</el-tag>
                    </div>
                </div>
            </s-tooltip>
        </el-tooltip>
    </div>
</template>

<script>
export default {
    data() {
        return {
            time: [],
            isShowContent: false,
            //=====================================日期参数====================================//
            activeName: "s-a"

        };
    },
    mounted() {},
    methods: {
        //=====================================获取远程数据==================================//
        //=====================================前后端交互====================================//
        //=====================================组件间交互====================================//
        //=====================================其他操作=====================================//
    }
};
</script>



<style lang="scss">
.s-time-select {
    display: flex;
    align-items: center;
    // 可选日期
    .select-item,
    .more {
        cursor: pointer;
        font-size: fz(12);
        padding: size(5) size(10);
        border: 1px solid $gray-300;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-right: size(10);
        border-radius: $border-radius-xs;
        &:hover {
            background: $gray-200;
        }
        &.active {
            transition: background 0.3s;
            color: $white;
            background: $theme-color;
        }
    }
    // 更多筛选
    .self-content {
        width: size(700);
        height: size(400);
        position: relative;
        display: flex;
        flex-direction: column;
        .area-wrap {
            height: size(300);
        }
        .province {
            padding: size(10);
            height: size(250);
            .province-list {
                height: size(200);
            }
        }
        .area-item {
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: size(60);
            height: size(25);
            background: $gray-200;
            margin-top: size(10);
            margin-right: size(10);
            border-radius: $border-radius-sm;
            &:hover {
                background: $gray-300;
            }
            &.active {
                color: $white;
                background: $theme-color;
            }
        }
    }
}
</style>
